import { Grid } from "@material-ui/core";
import React, {  } from "react";
import { DataCard } from "@ofqual/portal-components/components/DataCard/DataCard";
import { SelfDeclarationModel } from "../../domain/SelfDeclarationModel";

export const SelfDeclaration: React.FC<{
    selfDeclaration: SelfDeclarationModel | undefined;
}> = ({ selfDeclaration }) => {

var hasCourtJudgements = selfDeclaration?.hasCourtJudgements ? "Yes" : "No";
var hasBankruptcy = selfDeclaration?.hasBankruptcy ? "Yes" : "No";
var hasProfessionalMisconduct = selfDeclaration?.hasProfessionalMisconduct ? "Yes" : "No";
var hasBreach = selfDeclaration?.hasBreach ? "Yes" : "No";

return (
    <>
      <div style={{ overflowWrap: 'break-word' }}>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <DataCard
                showHeading={false}
                heading={null}
                items={[
                  {
                    itemType: "VALUE_WITH_DETAIL",
                    key: "Have you ever been convicted of the listed offences?",
                    value: { value: hasCourtJudgements, detail: selfDeclaration?.courtJudgementsDetails ?? ""},
                  },
                  {
                    itemType: "VALUE_WITH_DETAIL",
                    key: "Have you ever been declared bankrupt?",
                    value: { value: hasBankruptcy, detail: selfDeclaration?.bankruptcyDetails ?? ""},
                  },
                  {
                    itemType: "VALUE_WITH_DETAIL",
                    key: "Have you ever been guilty of grave professional misconduct?",
                    value: { value: hasProfessionalMisconduct, detail: selfDeclaration?.professionalMisconductDetails ?? ""},
                  },
                  {
                    itemType: "VALUE_WITH_DETAIL",
                    key: "Has your organisation, or you as an individual, ever been in breach of obligations related to tax or social security?",
                    value: { value: hasBreach, detail: selfDeclaration?.breachDetails ?? ""}
                  }
                ]}
                hasAction={false}
                actionDescription={null}
                actionButtonText={null}
                actionFunction={null}
                headingComponent={"h1"}
              />
            </Grid>
          </Grid>
      </div>
    </>
  );
};
